import type { PropsWithChildren } from 'react';

import { ToastViewport } from '@/shared/ui/toast';

export function App({ children }: PropsWithChildren): JSX.Element {
  return (
    <div className="h-full">
      {children}
      <ToastViewport />
    </div>
  );
}
